/**
 * An array of strings representing years from 1850 until current year.
 *
 * The array is prepending with an option for "Pre-1850".
 */

const minYear = 1850;
const maxYear = new Date().getFullYear();

const optionPre1850 = "Pre-1850";
const optionMaxYear = maxYear.toString();

const dateRangeOptions = () => {
  let years = [];
  for (let year = minYear; year <= maxYear; year++) {
    years.push(year.toString());
  }
  return [optionPre1850, ...years];
};

/**
 * The "Any classifications" option has a dynamic label representing the filtered counts.
 */
const optionClassificationAny = { label: 'Any classification', value: 'any' };
const formatOptionClassificationAny = (filteredTotal) => {
  return {
    label: `${optionClassificationAny.label} (${Number(filteredTotal).toLocaleString("en")})`,
    value: optionClassificationAny.value
  };
};

/**
 * The default parameters for the collection form.
 */
const defaultParams = {
  classifications: optionClassificationAny.value,
  date_begin: optionPre1850,
  date_end: optionMaxYear,
  include_uncataloged_works: false,
  on_view: false,
  q: '',
  recent_acquisitions: false,
  with_images: true
};

export const options = {
  dateRangeOptions,
  defaultParams,
  formatOptionClassificationAny,
  optionClassificationAny,
  optionMaxYear,
  optionPre1850,
};
